import ShButton from '@/components/Helpers/ShButton';
import ShModalWindow from '@/components/Helpers/ShModalWindow';

export default {
  name: 'ConfigurationModalStepOne',

  components: {
    ShButton,
    ShModalWindow,
  },

  data() {
    return {
      form: {
        domain: '',
      },
      widgetId: 0,
      rules: {
        domain: [
          { required: true, message: 'Nie podano nazwy strony', trigger: 'blur' },
          { min: 3, message: 'Nazwa strony musi zawierać minimum 3 znaki', trigger: 'blur' },
        ],
      },
    };
  },

  created() {
    this.setModalConfigurationCookie();
  },

  computed: {
    isLoading() {
      return this.$store.getters['app/pendingStoreActions'].includes([
        'domains/create',
        'widgets/getList',
        'widgets/create',
      ]);
    },
    widgetsList() {
      return this.$store.getters['widgets/list'];
    },
    user() {
      return this.$store.getters['authorization/user'];
    },
    domainsList() {
      return this.$store.getters['domains/list'];
    },
  },

  methods: {
    handleSave() {
      this.$refs.form.validate(async (isValid) => {
        if (!isValid) return;

        this.handleAddNewDomain();
        await this.handleCreateNewWidget();
        this.$emit('goToSetp', 2);
      });
    },

    async handleAddNewDomain() {
      if (!this.form.domain) return;
      this.$emit('onCreateDomain', this.form.domain);
      await this.$store.dispatch('domains/create', this.form.domain);
      this.$notify.success({
        title: 'Dodanie domeny',
        message: `Dodano domenę: ${this.form.domain}`,
        customClass: 'callmeweb-notification',
      });
      this.form.domain = null;
      this.$store.dispatch('domains/getList');
    },

    async handleCreateNewWidget() {
      await this.$store.dispatch('widgets/getList');
      if (this.widgetsList[0]) {
        this.widgetId = this.widgetsList[0].id;
      } else {
        this.widgetId = await this.$store.dispatch('widgets/create');
        this.$store.dispatch('widgets/getList');
      }

      this.$emit('onCreateWidget', this.widgetId);
    },

    setModalConfigurationCookie() {
      if (
        this.user.users_permissions_profiles_id_fk === 3
        && !document.cookie.includes('was_configuration_modal_shown')
        && this.domainsList.length <= 0
      ) {
        const date = new Date();
        const expireTime = date.getTime() + 1000 * 86400;
        date.setTime(expireTime);
        document.cookie = `was_configuration_modal_shown=true;expires=${date.toUTCString()};path=/`;
      }
    },
  },
};
